import React, { ChangeEvent } from "react";

interface CharacterFilterProps {
  searchTerm: string;
  statusFilter: string;
  genderFilter: string;
  onSearchChange: (value: string) => void;
  onStatusChange: (value: string) => void;
  onGenderChange: (value: string) => void;
  onReset: () => void;
}

const selectClass =
  "w-full rounded-lg border border-white/10 bg-space-800 px-3 py-2 text-sm text-white outline-none transition focus:border-portal-400";

const CharacterFilter: React.FC<CharacterFilterProps> = ({
  searchTerm,
  statusFilter,
  genderFilter,
  onSearchChange,
  onStatusChange,
  onGenderChange,
  onReset,
}) => {
  const hasFilters =
    searchTerm !== "" || statusFilter !== "" || genderFilter !== "";

  return (
    <div className="mb-8 grid gap-3 sm:grid-cols-2 lg:grid-cols-[2fr_1fr_1fr_auto]">
      <div>
        <label htmlFor="character-search" className="sr-only">
          Search by name
        </label>
        <input
          id="character-search"
          type="search"
          placeholder="Search by name…"
          value={searchTerm}
          onChange={(e: ChangeEvent<HTMLInputElement>) =>
            onSearchChange(e.target.value)
          }
          className="w-full rounded-lg border border-white/10 bg-space-800 px-3 py-2 text-sm text-white placeholder-slate-500 outline-none transition focus:border-portal-400"
        />
      </div>

      <div>
        <label htmlFor="status-filter" className="sr-only">
          Status
        </label>
        <select
          id="status-filter"
          value={statusFilter}
          onChange={(e: ChangeEvent<HTMLSelectElement>) =>
            onStatusChange(e.target.value)
          }
          className={selectClass}
        >
          <option value="">Any status</option>
          <option value="alive">Alive</option>
          <option value="dead">Dead</option>
          <option value="unknown">Unknown</option>
        </select>
      </div>

      <div>
        <label htmlFor="gender-filter" className="sr-only">
          Gender
        </label>
        <select
          id="gender-filter"
          value={genderFilter}
          onChange={(e: ChangeEvent<HTMLSelectElement>) =>
            onGenderChange(e.target.value)
          }
          className={selectClass}
        >
          <option value="">Any gender</option>
          <option value="male">Male</option>
          <option value="female">Female</option>
          <option value="genderless">Genderless</option>
          <option value="unknown">Unknown</option>
        </select>
      </div>

      {hasFilters && (
        <button
          type="button"
          onClick={onReset}
          className="rounded-lg border border-white/10 px-3 py-2 text-sm text-slate-300 transition hover:border-portal-400/60 hover:text-white"
        >
          Reset
        </button>
      )}
    </div>
  );
};

export default CharacterFilter;
